<user>
  <p>My username is: <b>{ props.name }</b></p>
</user>